import { Tabs, Tab } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import { IEditorState, ToolboxTabs, doSetToolboxTab } from "../../redux";
import { Dispatch } from "redux";

import BuildIcon from "@material-ui/icons/build";
import TuneIcon from "@material-ui/icons/tune";
import FormatIcon from "@material-ui/icons/formatpaint";

const apply = v => k => k(v);

interface ITabsProps {
    tab: ToolboxTabs;
    disabledTabs?: ToolboxTabs[];

    setTab: (tab: ToolboxTabs) => void;
}

const TabsWidget = props => apply({
    checkDisabled: v => props.disabledTabs !== undefined && props.disabledTabs.includes(v),
    getChild: (v, rest) => props.tab === v && rest.length > v ? rest[v] : null
})(({ checkDisabled, getChild }) => (
    <div>
        <Tabs 
            value={props.tab} 
            onChange={(_, value) => props.setTab(value)}
            indicatorColor="secondary"
        >
            <Tab icon={<BuildIcon />} disabled={checkDisabled(ToolboxTabs.Items)} />
            <Tab icon={<TuneIcon />} disabled={checkDisabled(ToolboxTabs.Atttributes)} />
            <Tab icon={<FormatIcon />} disabled={checkDisabled(ToolboxTabs.Styling)} />
        </Tabs>
        {getChild(ToolboxTabs.Items, props.children)}
        {getChild(ToolboxTabs.Atttributes, props.children)}
        {getChild(ToolboxTabs.Styling, props.children)}
    </div>
));

const stateToProps = (state: IEditorState) => ({
    tab: state.toolboxTab
})

const dispatchToProps = (dispatch) => ({
    setTab: v => dispatch(doSetToolboxTab(v)) 
})

export const EditorTabsWidget = connect(stateToProps, dispatchToProps)(TabsWidget);